const wowApp = require('angular').module('wowApp.shop');
wowApp.service('DeliveryService', ['$rootScope', 'Restangular', 'TrolleyService', 'AddressService', 'SettingsService', '$timeout', '$log', 'AtmService', 'ShopperService', require('./delivery-service')]);
wowApp.directive('wowDeliveryTimeTable', ['StorePickerService', 'MoveFocus', '$rootScope', 'ShopperService', 'AddressService', 'DeliveryService', 'BwsNotificationService', 'SettingsService', require('./delivery-timetable-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/delivery/index.js
 **/